// Copyright (c) 2016 Deere & Company

import Modal, {getDefaultState as getModalDefaultState} from '../../../product/shared/state/modal';

const PartsCoverageSearchStatusChangeModal = Modal;

export const getDefaultState = () => getModalDefaultState();

export default PartsCoverageSearchStatusChangeModal;



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/state/parts-coverage-search-status-change-modal.js